export const VIEW_HOME_PAGE = 'View home page';
export const VIEW_ABOUT = 'View about';
export const VIEW_CONTACT = 'View contact';

export const CLICK_RESUME = 'Click resume';
export const CLICK_GITHUB = 'Click github';
export const CLICK_LINKEDIN = 'Click LinkedIn';
export const CLICK_MAILTO_EMAIL = 'Click mailto email';

export const CLICK_INFINITE_DOGS = 'Click Infinite Dogs';
export const CLICK_LAYNE_BRITTON_NET = 'Click laynebritton.net';
export const CLICK_LIT_HUM_GAME = 'Click Lit Hum Game';
export const CLICK_QUICK_ATTUNEMENT = 'Click quick attunement';
export const CLICK_JL_TREE_CAP = 'Click JL Fast Treecapitator';
